import React from 'react';
import moment from 'moment-timezone';

const Result = ({
    match,
    selectedCompetition,
    handleTeamImageError,
    defaultTeamImage,
    siteURL
}) => {

    // const getMatchURL = (match, selectedCompetition) => {
    //     // Get the current path from window location
    //     const currentPath = window.location.pathname;

    //     // Base query parameters
    //     const baseParams = `type=scorecard&mId=${match.MatchID}&cId=${match.CompetitionID}&dId=${match.DivisionID}`;

    //     // Remove trailing slash if exists
    //     const cleanPath = currentPath.endsWith('/') ? currentPath.slice(0, -1) : currentPath;

    //     // Get the last segment of the path
    //     const pathSegments = cleanPath.split('/').filter(Boolean);
    //     const lastSegment = pathSegments[pathSegments.length - 1];

    //     // Construct the full URL with the current path segment
    //     return `${siteURL}${lastSegment}/?${baseParams}`;
    // };

    const getMatchURL = (match, selectedCompetition) => {
        console.log(selectedCompetition);
        // Base query parameters
        const baseParams = `type=scorecard&mId=${match.MatchID}&cId=${match.CompetitionID}&dId=${match.DivisionID}${selectedCompetition.SeasonID ? `&sId=${selectedCompetition.SeasonID}` : ''}`;

        // Check if we're in test environment
        if (process.env.REACT_APP_API_URL_ENV === 'test') {
            const testUrl = `${siteURL}?${baseParams}`;
            console.log('Test Environment URL:', testUrl);
            return testUrl;
        }

        // For non-test environment
        const currentPath = window.location.pathname;
        const cleanPath = currentPath.endsWith('/') ? currentPath.slice(0, -1) : currentPath;
        const pathSegments = cleanPath.split('/').filter(Boolean);
        const lastSegment = pathSegments[pathSegments.length - 1];
        const finalUrl = `${siteURL}${lastSegment}/?${baseParams}`;
        return finalUrl;
    };

    const shouldDisplayWicket = (wicket) => {
        return (wicket != 10);
    };

    const formatMatchTime = (GMTMatchDate, GMTMatchTime, MatchDate) => {
        if (!GMTMatchDate && !GMTMatchTime && MatchDate) {
            return moment(MatchDate).format('DD MMM YYYY');
        }

        if (!GMTMatchDate || !GMTMatchTime) {
            return MatchDate ? moment(MatchDate).format('DD MMM YYYY') : '';
        }

        const gmtTime = moment.utc(`${GMTMatchDate} ${GMTMatchTime}`, "YYYY-MM-DD HH:mm");
        const istTime = gmtTime.clone().tz('Asia/Kolkata');
        return `${istTime.format('DD MMM YYYY hh:mm A')} IST`;
    };

    const renderTeamScore = (team, innings) => {
        const scores = [];

        // First innings score
        if (innings === 1) {
            if (match['1FallScore']) {
                scores.push(
                    <div key="firstInnings" className="teamScore">
                        <span className="runs">
                            {match['1FallScore']}
                            {shouldDisplayWicket(match['1FallWickets']) && `/${match['1FallWickets']}`}
                        </span>
                        {match['1FallOvers'] && <span className="overs">({match['1FallOvers']})</span>}
                    </div>
                );
            }
        } else {
            if (match['2FallScore']) {
                scores.push(
                    <div key="secondInnings" className="teamScore">
                        <span className="runs">
                            {match['2FallScore']}
                            {shouldDisplayWicket(match['2FallWickets']) && `/${match['2FallWickets']}`}
                        </span>
                        {match['2FallOvers'] && <span className="overs">({match['2FallOvers']})</span>}
                    </div>
                );
            }
        }

        // Second innings scores (if applicable)
        if (match.CurrentInnings > 2) {
            const isSecondInningsFirstBatting = team === match.SecondInningsFirstBattingID;
            const inningsNumber = isSecondInningsFirstBatting ? '3' : '4';

            if (match[`${inningsNumber}FallScore`]) {
                scores.push(
                    <span key="ampersand" className="amp" style={{ fontSize: '16px' }}>&</span>
                );
                scores.push(
                    <div key="secondPhaseInnings" className="teamScore">
                        <span className="runs">
                            {match[`${inningsNumber}FallScore`]}
                            {shouldDisplayWicket(match[`${inningsNumber}FallWickets`]) &&
                                `/${match[`${inningsNumber}FallWickets`]}`}
                        </span>
                        {match[`${inningsNumber}FallOvers`] &&
                            <span className="overs">({match[`${inningsNumber}FallOvers`]})</span>}
                    </div>
                );
            }
        }

        return scores;
    };

    return (
        <div className="matchBox resultStrip uniform-grid " key={match.MatchID}>
            <div className="matchBox__left sm-flex sm-align-center">
                <div className="matchTeams sm-flex sm-align-center">
                    {match.HomeTeamID ? (
                        <>
                            <div className="tLogo">
                                <img alt={match.HomeTeamName} onError={handleTeamImageError}
                                    src={match.MatchHomeTeamLogo || match.HomeTeamLogo || defaultTeamImage} />
                            </div>
                            <div className="teamNames ">{match.HomeTeamName}</div>


                            <div className="runBox">
                                {match.HomeTeamID == match.FirstBattingTeamID ? (
                                    <div className="teamScore" >
                                        {match['1FallScore'] &&
                                            <span className="runs " >
                                                {match['1FallScore']}
                                                {shouldDisplayWicket(match['1FallWickets']) && `/${match['1FallWickets']}`}</span>
                                        }
                                        {match['1FallOvers'] &&

                                            <span className="overs" >({match['1FallOvers']}) </span>}
                                    </div>
                                ) : (
                                    <div className="teamScore" >
                                        {match['2FallScore'] &&
                                            <span className="runs " >   {match['2FallScore']}  {shouldDisplayWicket(match['2FallWickets']) && `/${match['2FallWickets']}`}</span>
                                        }
                                        {match['2FallOvers'] &&
                                            <span className="overs" >({match['2FallOvers']} )</span>}
                                    </div>
                                )}

                                {match.CurrentInnings > 2 && (
                                    <>


                                        {match.HomeTeamID == match.SecondInningsFirstBattingID ? (
                                            <>
                                                {match['3FallScore'] && <span className="amp" style={{ fontSize: '16px' }}>&</span>}
                                                <div className="teamScore" >
                                                    {match['3FallScore'] &&
                                                        <span className="runs " >
                                                            {match['3FallScore']}  {shouldDisplayWicket(match['3FallWickets']) && `/${match['3FallWickets']}`}</span>
                                                    }{match['3FallOvers'] &&
                                                        <span className="overs" >({match['3FallOvers']} )</span>}
                                                </div>
                                            </>) : (
                                            <>
                                                {match['4FallScore'] && <span className="amp" style={{ fontSize: '16px' }}>&</span>}
                                                <div className="teamScore" >

                                                    {match['4FallScore'] &&
                                                        <span className="runs " >   {match['4FallScore']}  {shouldDisplayWicket(match['4FallWickets']) && `/${match['4FallWickets']}`}</span>
                                                    }{match['4FallOvers'] &&
                                                        <span className="overs" >({match['4FallOvers']}) </span>}
                                                </div>
                                            </>)}
                                    </>
                                )}

                            </div>
                        </>
                    ) : (
                        <div className="matchTeams sm-flex sm-align-center">
                            {/* First Batting Team */}
                            <div className="tLogo">
                                <img alt={match.FirstBattingTeamName} onError={handleTeamImageError}
                                    src={match.HomeTeamLogo || defaultTeamImage} />
                            </div>
                            <div className="teamNames">{match.FirstBattingTeamName}</div>
                            <div className="runBox">
                                <div className="teamScore">
                                    {match['1FallScore'] && (
                                        <span className="runs">
                                            {match['1FallScore']} {shouldDisplayWicket(match['1FallWickets']) && `/${match['1FallWickets']}`}
                                        </span>
                                    )}
                                    {match['1FallOvers'] && <span className="overs">({match['1FallOvers']})</span>}
                                </div>
                                {match.CurrentInnings > 2 && (
                                    <>

                                        {match.FirstBattingTeamID == match.SecondInningsFirstBattingID ? (
                                            <>
                                                {match['3FallScore'] && <span className="amp" style={{ fontSize: '16px' }}>&</span>}
                                                <div className="teamScore">
                                                    {match['3FallScore'] && (
                                                        <span className="runs">
                                                            {match['3FallScore']} {shouldDisplayWicket(match['3FallWickets']) && `/${match['3FallWickets']}`}
                                                        </span>
                                                    )}
                                                    {match['3FallOvers'] && <span className="overs">({match['3FallOvers']})</span>}
                                                </div></>
                                        ) : (
                                            <>
                                                {match['4FallScore'] && <span className="amp" style={{ fontSize: '16px' }}>&</span>}
                                                <div className="teamScore">
                                                    {match['4FallScore'] && (
                                                        <span className="runs">
                                                            {match['4FallScore']} {shouldDisplayWicket(match['4FallWickets']) && `/${match['4FallWickets']}`}
                                                        </span>
                                                    )}
                                                    {match['4FallOvers'] && <span className="overs">({match['4FallOvers']})</span>}
                                                </div></>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    )}

                </div>
                <div className="tVs">vs </div>

                <div className="matchTeams sm-flex sm-align-center">
                    {match.AwayTeamID ? (
                        <>
                            <div className="tLogo">
                                <img alt={match.AwayTeamName} onError={handleTeamImageError}
                                    src={match.MatchAwayTeamLogo || match.AwayTeamLogo || defaultTeamImage} />

                            </div>
                            <div className="teamNames " >{match.AwayTeamName}</div>

                            <div >
                                <div className="runBox">
                                    {match.AwayTeamID == match.FirstBattingTeamID ? (
                                        <div className="teamScore">
                                            {match['1FallScore'] &&
                                                <span className="runs " >   {match['1FallScore']}  {shouldDisplayWicket(match['1FallWickets']) && `/${match['1FallWickets']}`}</span>
                                            }
                                            {match['1FallOvers'] &&
                                                <span className="overs" >({match['1FallOvers']}) </span>}
                                        </div>) : (
                                        <div className="teamScore" >
                                            {match['2FallScore'] &&
                                                <span className="runs " >  {match['2FallScore']}  {shouldDisplayWicket(match['2FallWickets']) && `/${match['2FallWickets']}`}</span>
                                            }
                                            {match['2FallOvers'] &&
                                                <span className="overs" >({match['2FallOvers']} )                                  </span>
                                            }
                                        </div>
                                    )}

                                    {match.CurrentInnings > 2 && (
                                        <>

                                            {match.AwayTeamID == match.SecondInningsFirstBattingID ? (<>
                                                {match['3FallScore'] && <span className="amp" style={{ fontSize: '16px' }}>&</span>}
                                                <div className="teamScore" >
                                                    {match['3FallScore'] &&
                                                        <span className="runs " >
                                                            {match['3FallScore']}  {shouldDisplayWicket(match['3FallWickets']) && `/${match['3FallWickets']}`}</span>
                                                    }
                                                    {match['3FallOvers'] &&
                                                        <span className="overs" >({match['3FallOvers']} )</span>}
                                                </div>
                                            </>) : (<>
                                                {match['4FallScore'] && <span className="amp" style={{ fontSize: '16px' }}>&</span>}

                                                <div className="teamScore" >
                                                    {match['4FallScore'] &&
                                                        <span className="runs " >   {match['4FallScore']}  {shouldDisplayWicket(match['4FallWickets']) && `/${match['4FallWickets']}`}</span>
                                                    }
                                                    {match['4FallOvers'] &&
                                                        <span className="overs" >({match['4FallOvers']}) </span>}
                                                </div>
                                            </>)}
                                        </>
                                    )}

                                </div>
                            </div>

                        </>
                    ) : (
                        <div className="matchTeams sm-flex sm-align-center">
                            <div className="tLogo">
                                <img alt={match.SecondBattingTeamName} onError={handleTeamImageError}
                                    src={match.AwayTeamLogo || defaultTeamImage} />
                            </div>
                            <div className="teamNames">{match.SecondBattingTeamName}</div>
                            <div className="runBox">
                                <div className="teamScore">
                                    {match['2FallScore'] && (
                                        <span className="runs">
                                            {match['2FallScore']} {shouldDisplayWicket(match['2FallWickets']) && `/${match['2FallWickets']}`}
                                        </span>
                                    )}
                                    {match['2FallOvers'] && <span className="overs">({match['2FallOvers']})</span>}
                                </div>

                                {match.CurrentInnings > 2 && (
                                    <>

                                        {match.SecondBattingTeamID == match.SecondInningsFirstBattingID ? (
                                            <>
                                                {match['3FallScore'] && <span className="amp" style={{ fontSize: '16px' }}>&</span>}
                                                <div className="teamScore">
                                                    {match['3FallScore'] && (
                                                        <span className="runs">
                                                            {match['3FallScore']} {shouldDisplayWicket(match['3FallWickets']) && `/${match['3FallWickets']}`}
                                                        </span>
                                                    )}
                                                    {match['3FallOvers'] && <span className="overs">({match['3FallOvers']})</span>}
                                                </div>
                                            </>
                                        ) : (<>
                                            {match['4FallScore'] && <span className="amp" style={{ fontSize: '16px' }}>&</span>}
                                            <div className="teamScore">
                                                {match['4FallScore'] && (
                                                    <span className="runs">
                                                        {match['4FallScore']} {shouldDisplayWicket(match['4FallWickets']) && `/${match['4FallWickets']}`}
                                                    </span>
                                                )}
                                                {match['4FallOvers'] && <span className="overs">({match['4FallOvers']})</span>}
                                            </div></>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="matchBox__right sm-flex sm-align-center">

                <div className="match-tournament-name">
                    {match.CompetitionName ||
                        (selectedCompetition?.CompetitionID === match.CompetitionID && selectedCompetition?.CompetitionName)}
                </div>
                <div className="matchInfom sm-flex">
                    <div className="matchInfom_left">
                        <div className="match-order">
                            <span className="ng-binding" ></span>
                            <span>{formatMatchTime(match.GMTMatchDate, match.GMTMatchTime, match.MatchDate)}</span>
                        </div>
                        <div className="match-ground-name">
                            <span className="matGround " >{match.GroundName}</span>
                            <span className="">,&nbsp; </span>
                            <span className="matPlace ng-binding" >{match.city} </span>
                        </div>
                    </div>
                    <div className="matchInfom_right">
                        {(match.Comments !== undefined && match.Comments !== '') && (
                            <div className="matchResult">
                                {match.Comments}
                            </div>
                        )}
                        {(!match.MatchComments && match.TossDetails !== '') && (
                            <div className="matchSummary">
                                {match.TossDetails}
                            </div>
                        )}

                    </div>
                </div>

                {(match.FirstBattingSummary != null &&
                    match.FirstBattingSummary !== '') && (
                        <div className="btnWrap">
                            <a href={getMatchURL(match, selectedCompetition)} className="btnScorecard">
                                <span className="ng-binding"></span>Match Centre
                            </a>

                        </div>
                    )}

            </div>
        </div>
    );
};

export default Result;